import { UserModel } from 'models'

export default {
  model: UserModel,
  storage: 'local',
}
